<form [formGroup]="form">
    <mat-form-field class="full-width">
        <mat-label>Asociar factura</mat-label>
        <input type="text" #invoiceSearchCtrl formControlName="BillingInvoiceAssociate" matInput placeholder="Ingrese los últimos números de la factura" (input)="onBillingInvoiceAssociateChange()" [matAutocomplete]="autInvoiceSearch">
        <mat-autocomplete #autInvoiceSearch="matAutocomplete" (optionSelected)="billingInvoiceAssociateFilterSelected($event.option.value)" [displayWith]="displayFn">
            <mat-option *ngFor="let billingInvoiceAssociatecFilter of billingInvoiceAssociatecFilters" [value]="billingInvoiceAssociatecFilter">
                <b>{{ billingInvoiceAssociatecFilter.Number }}</b> {{ billingInvoiceAssociatecFilter.InvoiceDate | date: "dd/MM/yyyy"  }} {{ billingInvoiceAssociatecFilter.BusinessName }}
            </mat-option>
        </mat-autocomplete>
        <mat-spinner *ngIf="loading" matSuffix [diameter]="20"></mat-spinner>
    </mat-form-field>
</form>
